export namespace Constants {
  export const ITEMSPERPAGE: number = 10;
  export const DEFAULTDEPARTMENTIDSETTINGNAME: string = "defaultDepartmentId";
  export const MUSTCHANGEPASSWORDSETTINGNAME: string = "mustChangePassword";
}
